import { Toolbar } from '@kerfjs/ui/toolbar';
import { ToolbarText } from '@kerfjs/ui/toolbar-text';
import { type SafeHtml } from 'kerfjs';

import { analysisReport, decisions, editorSegment, workspace } from '../../../data/state.js';
import { demandReadOnly } from '../../../lib/context.js';
import { AttachmentControl } from './attachment-control.js';
import { PrimaryAddControl } from './primary-add-control.js';
import { ShareControl } from './share-control.js';

const SEGMENT_TITLES: Record<string, string> = {
  info: 'Info',
  lines: 'Line Items',
  quotes: 'Quotes',
  files: 'Documents',
  summary: 'Summary / Outcomes',
  'decision-summary': 'Summary / Outcomes',
};

export function DemandEditorSubHeader(): SafeHtml {
  if (workspace.value === null) return <></>;
  const segment = editorSegment.value;
  const title = SEGMENT_TITLES[segment] ?? 'Demand';
  let actions: SafeHtml | undefined;
  if (!demandReadOnly()) {
    switch (segment) {
      case 'lines':
        actions = (
          <>
            <AttachmentControl
              input={
                <input
                  class="app-visually-hidden"
                  type="file"
                  multiple
                  aria-hidden="true"
                  tabindex={-1}
                  data-intake-upload="demand"
                  hidden
                />
              }
            />
            <PrimaryAddControl action="intake-add-row" label="New Item…" />
          </>
        );
        break;
      case 'quotes':
        actions = (
          <>
            <AttachmentControl
              input={
                <input
                  class="app-visually-hidden"
                  type="file"
                  multiple
                  aria-hidden="true"
                  tabindex={-1}
                  data-quote-upload="quotation"
                  hidden
                />
              }
            />
            <PrimaryAddControl action="quote-add-open" label="Add Quotation…" />
          </>
        );
        break;
      case 'files':
        actions = (
          <AttachmentControl
            input={
              <input
                class="app-visually-hidden"
                type="file"
                multiple
                aria-hidden="true"
                tabindex={-1}
                data-intake-upload="auto"
                hidden
              />
            }
          />
        );
        break;
      case 'summary':
      case 'decision-summary':
        if (analysisReport.value !== null || decisions.value.length > 0) actions = <ShareControl />;
        break;
      case 'info':
        break;
    }
  }
  return (
    <div class="demand-editor-sub-header">
      <Toolbar
        label={`${title} Section`}
        leading={<ToolbarText text={title} size="xlarge" id="editor-subheader-title" headingLevel={2} />}
        trailing={actions}
      />
    </div>
  );
}
